import React from 'react';
import { Container } from '@material-ui/core';
import { Button } from '@rcg/ui-react';
import useStyles from './index.styles';
import Picture from '../Picture';
import { ReactComponent as RoyalUpSvg } from '../../assets/svg/royalUp.svg';
import { sendTrackingParams } from '../../commons/tracking/tracking';

const RoyalUpContainer = ({ urlPathViewUpgrades, dictionaries }) => {
  const classes = useStyles();
  const images = [
    {
      url: 'https://assets.dm.rccl.com/is/image/RoyalCaribbeanCruises/royal/data/ship/symphony/symphony-of-the-seas-ultimate-family-suite-master-bedroom.jpg?$375x205$',
      size: '375x205',
      key: '375w',
    },
    {
      url: 'https://assets.dm.rccl.com/is/image/RoyalCaribbeanCruises/royal/data/ship/symphony/symphony-of-the-seas-ultimate-family-suite-master-bedroom.jpg?$635x222$',
      size: '635x222',
      key: '768w',
    },
    {
      url: 'https://assets.dm.rccl.com/is/image/RoyalCaribbeanCruises/royal/data/ship/symphony/symphony-of-the-seas-ultimate-family-suite-master-bedroom.jpg?$704x222$',
      size: '704x222',
      key: '1024w',
    },
    {
      url: 'https://assets.dm.rccl.com/is/image/RoyalCaribbeanCruises/royal/data/ship/symphony/symphony-of-the-seas-ultimate-family-suite-master-bedroom.jpg?$932x330$',
      size: '932x330',
      key: '1440w',
    },
  ];

  const redirectRoyalUp = () => {
    sendTrackingParams(
      {
        eventType: 'interaction',
        interaction: 'viewUpgrade:Clicked',
      },
      false,
    );
    setTimeout(() => {
      window.location.href = urlPathViewUpgrades;
    }, 1000);
  };

  return (
    <div className={classes.actionCard}>
      <Container
        maxWidth={false}
        className={classes.hero}
        data-testid="royal-container"
        tabIndex={0}
        onClick={redirectRoyalUp}>
        <Picture
          className={classes.backgroundImage}
          images={images}
          sizes="(max-width: 375px) 375px,
          (max-width: 768px) 768px,
          (max-width: 1024px) 1024px,
          1440px"
          defaultImage={images.length > 0 ? images[images.length - 1].url : ''}
        />
        <div className={classes.gradientOverlay} />
        <div className={classes.heroBody}>
          <div className={classes.logoRoyalUp}>
            <RoyalUpSvg />
          </div>
          <div className={classes.row}>
            <div className={classes.containerDescription}>
              <div>
                <p>{dictionaries?.amendHeroRoyalUpSubtitle}</p>
              </div>
              <div>
                <p>{dictionaries?.amendHeroRoyalUpDescription}</p>
              </div>
            </div>
            <div className={classes.buttonSection}>
              <Button
                tabIndex={-1}
                data-testid="reinforce-button"
                variant="contained"
                color="primary"
                role="presentation"
                className={classes.button}>
                {dictionaries?.amendHeroRoyalUpButton}
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
export default RoyalUpContainer;
